import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import '@styles/styles.scss'
import App from './App.vue'
import { useQueryStore } from '@stores/queryStore'

const pinia = createPinia()
const app = createApp(App)

app.use(pinia)
app.use(router)

router.isReady().then(() => {
  useQueryStore()
  app.mount('#app')
})
